import { uniqueId } from "lodash-es";
import React from "react";

import { EDialogType, IDialog, IDialogBase, IDialogsActions, IDialogsContext, ITypedDialog } from "./types";

export const DialogsContext = React.createContext({} as IDialogsContext);
const MessegesProvider = DialogsContext.Provider;
const DialogsConsumer = DialogsContext.Consumer;

export interface IDialogsProps {}

interface State extends IDialogsContext {}

export class DialogsProvider extends React.Component<IDialogsProps, State> {
  constructor(props: IDialogsProps) {
    super(props);

    this.state = {
      dialogs: [],
      confirmDialog: this.confirmDialog,
      alertDialog: this.alertDialog,
      deleteDialog: this.deleteDialog,
    };
  }

  getId = () => {
    return uniqueId("dialog");
  };

  createDialog = (payload: ITypedDialog): IDialog => {
    const id = this.getId();
    return { ...payload, id };
  };

  confirmDialog = (params: IDialogBase) => {
    const dialog = this.createDialog({ ...params, type: EDialogType.CONFIRM });
    this.openDialog(dialog);
  };

  alertDialog = (params: IDialogBase) => {
    const dialog = this.createDialog({ ...params, type: EDialogType.ALERT });
    this.openDialog(dialog);
  };

  openDialog = (dialog: IDialog) => {
    const dialogs = [...this.state.dialogs, dialog];
    this.setState({ dialogs });
  };

  deleteDialog = (dialog: IDialog) => {
    const dialogs = this.state.dialogs.filter(d => d.id !== dialog.id);
    this.setState({ dialogs });
  };

  render() {
    const { children } = this.props;
    return <MessegesProvider value={this.state}>{children}</MessegesProvider>;
  }
}

export interface IWithDialogsProps extends IDialogsActions {
  dialogs: IDialog[];
}

export function withDialogs<P extends IWithDialogsProps>(WrappedComponent: React.ComponentType<P>) {
  type Props = Omit<P, keyof IWithDialogsProps>;
  return class WithDialogs extends React.Component<Props> {
    render() {
      return <DialogsConsumer>{value => <WrappedComponent {...this.props} {...(value as any)} />}</DialogsConsumer>;
    }
  };
}

export interface IWithDialogsActions extends IDialogsActions {}

export function withDialogsActions<P extends IDialogsActions>(WrappedComponent: React.ComponentType<P>) {
  return class WithDialogsActions extends React.Component<Omit<P, keyof IWithDialogsActions>> {
    render() {
      return (
        <DialogsConsumer>
          {value => {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { dialogs, ...actions } = value;

            return <WrappedComponent {...this.props} {...(actions as any)} />;
          }}
        </DialogsConsumer>
      );
    }
  };
}
